<template>
  <div>
    <HeaderView></HeaderView>
    <router-view></router-view>
    <MainFooter></MainFooter>
  </div>
</template>
<script>
import HeaderView from "./components/HeaderView";
import MainFooter from "./components/Footer";
export default {
  components: {
    HeaderView,
    MainFooter,
  },
};
</script>
